import * as React from "react";
import {BoxFieldListControlComponentOptionProps} from "../../types/types";
import './boxFieldListControl.component.scss';

export const BoxFieldListControlComponent = ( {name, onChange, theme, options, value}: BoxFieldListControlComponentOptionProps ) => {
    return (<div className={`button-list-wrapper ${theme}`}>
        {options.map( ( option ) => {
            const className = option.value == value ? "button-list-item selected" : "button-list-item";
            const width = 100 / options.length + '%';
            return (<div key={option.value} style={{width: width}} className={className} onClick={() => onChange( option.value )}> {option.text}</div>);
        } )}
    </div>);
}
